import React from 'react'
import {reduxForm} from 'redux-form'
import SelectWrap from '../shared/select/SelectWrap'
import styles from './claims.scss'
import {find} from 'lodash/collection'
import Input from '../input'
import {trimObject, hasContent} from 'lib/helpers'

import i18n from 'lib/i18n'
const _ = i18n('claims')

const fieldType = {
	clientName: 'multiple',
	brokerNumber: 'multiple',
	claimDate: 'multiple',
	creationDate: 'multiple',
	contractNumber: 'unique',
	clientNumber: 'unique',
	claimNumber: 'unique',
	claimRefBroker: 'unique',
	licencePlate: 'multiple',
	state: 'always',
}

const validate = values => {
	const errors = {}
	const formattedData = trimObject(values)
	const isEmpty = !hasContent(formattedData)
	if (isEmpty) {
		errors._error = 'emptyFields'
	}
	return errors
}

@reduxForm({
	form: "claims",
	fields: Object.keys(fieldType),
	validate,
})
export default class ClaimsForm extends React.Component {
	static propTypes = {
		fields: React.PropTypes.object,
		handleSubmit: React.PropTypes.func,
		error: React.PropTypes.string,
	}

	render() {
		const columns = [
			[
				'clientName',
				'brokerNumber',
				'claimDate',
				'creationDate',
			],
			[
				'contractNumber',
				'clientNumber',
				'claimNumber',
				'claimRefBroker',
				'licencePlate',
			],
		]

		const options = [
			{value: '', label: `${_('all')}`},
			{value: 'open', label: `${_('active')}`},
			{value: 'closed', label: `${_('inactive')}`},
		]

		const {fields, fields: {state}, handleSubmit, error} = this.props
		const invalid = error === 'emptyFields'
		const usedField = find(fields, field => field.value)
		const usedType = usedField && fieldType[usedField.name] !== 'always' && fieldType[usedField.name]
		return (
			<form id="casper_claims" onSubmit={handleSubmit} name="claimsSearchForm" className={`claimsSearchForm`}>
				<div className={styles.formContainer}>
					{columns.map((col, i) => (
						<div key={i} className={styles.column}>
							{col.map((name) => {
								let isDisabled = false
								if (usedType && usedField.name !== name) {
									if (usedType === 'unique') {
										isDisabled = true
									} else {
										isDisabled = (usedType !== fieldType[name])
									}
								}
								return (
									<div key={name} className={styles.searchContainer}>
										<div className={styles.label}>
											{_(name)}
										</div>
										<div className={styles.claimsSearchInput}>
                                            <Input
                                                type="text"
												autoFocus={name === 'clientName'}
												disabled={isDisabled}
												{...fields[name]}
											/>
										</div>
									</div>
								)
							})}
						</div>
					))}
					<div className={styles.dropContainer}>
						<div className={styles.dropdown}>
							<div className={styles.label}>
								{_('state')}
							</div>
							<div className={styles.claimsSearchDropdown}>
								<SelectWrap
									options={options}
									{...state}
									onBlur={e => {e.preventDefault()}}
								/>
							</div>
						</div>
					</div>
				</div>
				<button id="casper_claimsButton" type="submit" disabled={invalid} onClick={handleSubmit} className={styles.greyButton}>{_('submitbutton')}</button>
			</form>
		)
	}
}



// WEBPACK FOOTER //
// ./components/claims/form.jsx